import { typeCustomer } from "./customer"
import { mutationUpdateCustomerCharacteristics } from "./mutations/mutationUpdateCustomerCharacteristics"
import { queryAllAssignedCustomers } from "./queries/queryAllAssignedCustomers"
import { queryCustomer } from "./queries/queryCustomer"
import { queryCustomerBaseInformation } from "./queries/queryCustomerBaseInformation"
import { queryCustomers } from "./queries/queryCustomers"
import { queryCustomersListCheck } from "./queries/queryCustomersListCheck"
import { queryIdmCustomers } from "./queries/queryIdmCustomers"
import { resolverCustomer } from "./resolvers/resolverCustomer"

const customerSchema = {
  types: [typeCustomer],
  resolvers: {
    Query: {
      ...queryCustomer,
      ...queryCustomerBaseInformation,
      ...queryCustomers,
      ...queryAllAssignedCustomers,
      ...queryIdmCustomers,
      ...queryCustomersListCheck,
    },
    Mutation: {
      ...mutationUpdateCustomerCharacteristics,
    },
    ...resolverCustomer,
  },
}

export default customerSchema
